<p-drawer
    [visible]="layoutService.state.configSidebarVisible()"
    (visibleChange)="layoutService.state.configSidebarVisible.set($event)"
    header="Theme"
    position="right"
    styleClass="w-20"
>
    <div class="w-full !text-center">
        <!-- DARK MODE -->
        <h3>{{ 'setting.dark-mode' | translate }}</h3>
        <p-toggleSwitch [(ngModel)]="darkMode" [ngModelOptions]="{standalone: true}"/>
        
        <h3 class="mt-3">{{ 'setting.sidebar-dark-mode' | translate }}</h3>
        <p-toggleSwitch [disabled]="darkMode" [(ngModel)]="sidebarDark" [ngModelOptions]="{standalone: true}"/>

        <!-- SCALE -->
        <h3 class="mt-3">{{ 'setting.text-scale' | translate }}</h3>
        <div class="flex items-center w-full justify-center">
            <p-button
                icon="fa fa-minus"
                (onClick)="decrementScale()"
                variant="text"
                rounded="true"
                styleClass="w-2rem h-2rem mr-2"
                [disabled]="scale === scales[0]"
            />
            <div class="flex gap-2 justify-center">
                @for (s of scales; track s) {
                    <i
                        class="fa fa-circle text-300"
                        [ngClass]="{ 'text-primary-500': s === scale }"
                    ></i>
                }
            </div>
            <p-button
                icon="fa fa-plus"
                (onClick)="incrementScale()"
                variant="text"
                rounded="true"
                styleClass="w-2rem h-2rem ml-2"
                [disabled]="scale === scales[scales.length - 1]"
            />
        </div>

        <!-- MENU MODE -->
        <h3 class="mt-3">Menu Mode</h3>
        <div class="flex flex-wrap gap-2 justify-center">
            <p-button 
                label="Static" 
                icon="fa fa-th-large" 
                (onClick)="sidebarService.setLayoutMode('static')" 
                [outlined]="sidebarService.layoutModeSig() !== 'static'" 
                size="small"
                styleClass="w-full"
            ></p-button>
            <p-button 
                label="Overlay" 
                icon="fa fa-window-restore" 
                (onClick)="sidebarService.setLayoutMode('overlay')" 
                [outlined]="sidebarService.layoutModeSig() !== 'overlay'" 
                size="small"
                styleClass="w-full"
            ></p-button>
            <p-button 
                label="Reveal" 
                icon="fa fa-eye" 
                (onClick)="sidebarService.setLayoutMode('reveal')" 
                [outlined]="sidebarService.layoutModeSig() !== 'reveal'" 
                size="small"
                styleClass="w-full"
            ></p-button>
            <p-button 
                label="Horizontal" 
                icon="fa fa-arrows-alt-h" 
                (onClick)="sidebarService.setLayoutMode('horizontal')" 
                [outlined]="sidebarService.layoutModeSig() !== 'horizontal'" 
                size="small"
                styleClass="w-full"
            ></p-button>
        </div>
    </div>
</p-drawer>
